<template>
    <div class="Classroom no-trans" v-loading="loading">
        <div class="Classroom_top">
            <div class="banners">
                <img src="../../../assets/img/index/law/banner1.png" alt="">
            </div>
            <div class="check_box">
                <div class="check_item" v-for="(item,index) in visible_categories" :key="index" >
                    <div class="check_img">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="check_info">
                        <div class="check_title" role="link" tabindex="0" @keydown.enter.prevent="handle_path_video(item)" @click="handle_path_video(item)">{{ item.title }}</div>
                        <div class="check_list">
                            <div class="check_list_item" v-for="(items,indexs) in item.child" :key="indexs" role="link" tabindex="0" @keydown.enter.prevent="handle_path_video(item,items)" @click="handle_path_video(item,items)">{{ items.title }}</div>
                        </div>
                    </div>
                </div>
                <button v-if="mobile_view && check_list.length>4" class="category_toggle" type="button" :aria-expanded="mobile_categories_open" @click="mobile_categories_open=!mobile_categories_open">{{ mobile_categories_open ? '收起分类' : '全部分类' }} <i :class="mobile_categories_open ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" aria-hidden="true"></i></button>
            </div>
            <div class="LAW_CLASS">
                <div class="LAW_CLASS_box">
                    <div class="LAW_CLASS_title" role="link" tabindex="0" @keydown.enter.prevent="handle_path_video()" @click="handle_path_video()">
                        <div class="titles">{{ mobile_view ? '视频课堂' : '法律课堂' }} </div>
                        <div class="titles_en">
                            LAW CLASS 
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                        <span v-if="mobile_view" class="mobile_more">更多 <i class="el-icon-arrow-right" aria-hidden="true"></i></span>
                    </div>
                    <div class="LAW_CLASS_list">
                        <div class="items" v-for="(item,index) in list1" :key="index" role="link" tabindex="0" @keydown.enter.prevent="$router.push('/Classroom_list_video_detial?id='+item.id)" @click="$router.push('/Classroom_list_video_detial?id='+item.id)">
                            <div class="item_imgs">
                                <!-- <img src="../../../assets/img/index/home/lsuo.png" alt=""> -->
                                <img :src="item.thumb" alt="">
                                <i v-if="mobile_view" class="el-icon-video-play mobile_play" aria-hidden="true"></i>

                            </div>
                            <div class="item_info">
                                <div class="info_title">
                                    {{ item.title }}
                                    
                                </div>
                                <div class="item_tages">
                                    <div class="tages">
                                        <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                        {{ item.views }}
                                    </div>
                                    <div class="tages">
                                        <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                        {{ mobile_view ? String(item.pub_time || '').split(' ')[0] : item.pub_time }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="items2"></div>
                        <div v-if="mobile_view && !loading && !list1.length" class="mobile_empty">暂无视频课程</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Classroom_bom">
            <div class="LAW_CLASS_box">
                    <div class="LAW_CLASS_title" role="link" tabindex="0" @keydown.enter.prevent="handle_path_text()" @click="handle_path_text()">
                        <div class="titles">{{ mobile_view ? '图文课堂' : '法律课堂' }} </div>
                        <div class="titles_en">
                            LAW CLASS 
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                        <span v-if="mobile_view" class="mobile_more">更多 <i class="el-icon-arrow-right" aria-hidden="true"></i></span>
                    </div>
                    <div class="LAW_CLASS_list">
                        <div class="items" :class="{items_bg:index==0}" v-for="(item,index) in list2" :key="index" role="link" tabindex="0" @keydown.enter.prevent="$router.push('/Classroom_list_text_detial?id='+item.id)" @click="$router.push('/Classroom_list_text_detial?id='+item.id)">
                            <div class="item_no">
                                <img src="../../../assets/img/index/law/no.png" alt="">
                                <span>NO.{{ index+1 }}</span>
                            </div>
                            <div class="item_titles">
                                {{ item.title }}
                            </div>
                            <div class="item_const">
                                {{ item.desc }}
                            </div>
                            <div class="item_tages">
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                    {{ item.views }}
                                </div>
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                    {{ item.comment_num }}
                                </div>
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                    {{ mobile_view ? String(item.pub_time || '').split(' ')[0] : item.pub_time }}

                                </div>
                            </div>
                        </div>
                        <div class="items2"></div>
                        <div v-if="mobile_view && !loading && !list2.length" class="mobile_empty">暂无图文课程</div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'
 
 

export default {
    components: {
        
        
    },
    name: "homes",
    data() {
        return {
            loading:false,
            mobile_categories_open:false,
            list1:[],
            list2:[],
            check_list:[]
        }
    },
    computed: {
        visible_categories() {
            return this.mobile_view && !this.mobile_categories_open ? this.check_list.slice(0,4) : this.check_list
        },
    },
    watch: {
        
    },
    created() {
        this.get_type_list()
        this.get_list1()
        this.get_list2()
    },
    methods: {
        get_type_list(){
            this.loading=true
            this.$api("lessonTypeList", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂分类',res)
                if (res.code == 1) {
                    this.check_list=res.data.splice(0,8)
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list1(){
            this.loading=true
            this.$api("lessonList", {
                 type:1,
                 limit:6,
                 recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表1',res)
                if (res.code == 1) {
                    this.list1=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list2(){
            this.loading=true
            this.$api("lessonList", {
                type:2,
                limit:9,
                recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表2',res)
                if (res.code == 1) {
                    this.list2=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_path_text(item){
            this.$router.push({
                path:'/Classroom_list_text'
            })
        },
        handle_path_video(item={},items={}){
            this.$router.push({
                path:'/Classroom_list_video',
                query:{
                    item_id:item.id||'',
                    items_id:items.id||''
                },   
            })
        },
    
    },

}
</script>
<style scoped lang="less">
.Classroom{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    // padding:21px ;
    // padding-bottom: 100px;
    .Classroom_top{
        .banners{
            width: 100%;
            height: 480px;
            position: relative;
            z-index: 1;
            img{
                width: 100%;
                height: 480px;
            }
        }
        .check_box{
            width: 1440px;
            height: 258px;
            background: #FFFFFF;
            box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
            border-radius: 8px 8px 8px 8px;
            margin: auto;
            margin-top: -149px;
            position: relative;
            z-index: 2;
            padding: 40px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .check_item{
                width: 25%;
                // padding-right: 30px;
                // height: 50%;
                margin-bottom: 30px;
                display: flex;
                .check_img{
                    img{
                        width: 32px;
                    }
                }
                .check_info{
                    padding-left: 16px;
                    .check_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        cursor: pointer;

                    }
                    .check_list{
                        width: 240px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 6px;
                        .check_list_item{
                            margin-right: 24px;         
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            margin-bottom: 6px;
                            cursor: pointer;
                        }
                    }

                }
                
            }
        }
        .LAW_CLASS{
            .LAW_CLASS_box{
                width: 1440px;
                margin: auto;
                .LAW_CLASS_title{
                   display: flex;
                   align-items: end;
                   padding-top: 56px;
                   cursor: pointer;
                   .titles{
                       font-family: Microsoft YaHei, Microsoft YaHei;
                       font-weight: bold;
                       font-size: 36px;
                       color: #333333;
                    }
                    .titles_en{
                        font-weight: 400;
                        font-size: 24px;
                        color: rgba(55, 124, 253, 0.37);
                        margin-left: 16px;
                        img{
                            width: 24px;
                            margin-left: 20px;
                        }
                    }

                }
                .LAW_CLASS_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding-top: 40px;
                    .items{
                        width: 453px;
                        height: 390px;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                        border-radius: 8px 8px 8px 8px;
                        margin-bottom: 40px;
                        .item_imgs{
                            width: 100%;
                            height: 255px;
                            img{
                                width: 100%;
                                height: 255px;
                            }
                        }
                        .item_info{
                            padding: 20px 24px 24px 24px;
                            .info_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 20px;
                                color: #000B33;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient: vertical;
                            }
                            .item_tages{
                                display: flex;
                                align-items: center;
                                padding-top: 18px;
                                .tages{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                    margin-right: 24px;
                                    img{
                                        // width: 25px;
                                        height: 19px;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }

                    }
                    .items2{
                        width: 453px;
                    }
                }
            }
        }
    }
    .Classroom_bom{
        width: 100%;
        // height: 1053px;
        padding-bottom: 100px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 80px;
        .LAW_CLASS_box{
                width: 1440px;
                margin: auto;
                .LAW_CLASS_title{
                   display: flex;
                   align-items: end;
                   padding-top: 56px;
                   cursor: pointer;
                   .titles{
                       font-family: Microsoft YaHei, Microsoft YaHei;
                       font-weight: bold;
                       font-size: 36px;
                       color: #333333;
                    }
                    .titles_en{
                        font-weight: 400;
                        font-size: 24px;
                        color: rgba(55, 124, 253, 0.37);
                        margin-left: 16px;
                        img{
                            width: 24px;
                            margin-left: 20px;
                        }
                    }

                }
                .LAW_CLASS_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding-top: 40px;
                    .items{ 
                        position: relative;
                        width: 453px;
                        height: 217px;
                        // background: #FFFFFF;
                        background-image: url('../../../assets/img/index/law/bg2.png');
                        background-size: 100%;
                        margin-bottom: 50px;
                        border-radius:8px 8px 8px 8px;
                        padding:24px 24px 20px 24px;
                       
                        .item_no{
                            width: 76px;
                            height: 60px;
                            position: absolute;
                            right: 30px;
                            top: -10px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #FFFFFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 76px;
                                height: 60px;
                                z-index: 1;
                            }
                            span{
                                position: relative;
                                z-index: 2;
                                margin-left: 10px;
                            }
                        }
                        .item_titles{
                            width: 300px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #333333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp:1;
                            -webkit-box-orient: vertical;

                        }
                        .item_const{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp:3;
                            -webkit-box-orient: vertical;
                            padding-top: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            // color: #FFFFFF;
                            color: #666666;
                         

                        }
                        .item_tages{
                            margin-top: 24px;
                            border-top:1px solid  #D7D7D7;
                            display: flex;
                            align-items: center;
                            padding-top: 16px;
                            .tages{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-right: 24px;
                                img{
                                    height: 19px;
                                    margin-right: 8px;
                                }
                            }
                        }


                    }
                    .items_bg{
                        background-image: url('../../../assets/img/index/law/bg1.png');
                        // background-image: none;
                        // background-color: red;
                        .item_titles{
                            color:#FFFFFF ;
                        }
                        .item_const{
                            color:#FFFFFF ;
                        }
                        .item_tages{
                            .tages{
                                color:#FFFFFF ;
                            }
                        }

                    }
                    .items2{
                        width: 453px;
                    }
                }
            }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .Classroom.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .Classroom.no-trans .Classroom_top .banners {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .Classroom_top .banners img {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .Classroom_top .check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin: auto;
        margin-top: -16px;
        padding: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item {
        margin-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item .check_img img {
        width: 32px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item .check_info {
        padding-left: 16px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item .check_info .check_title {
        font-size: 18px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item .check_info .check_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
        padding-top: 6px;
    }
    .Classroom.no-trans .Classroom_top .check_box .check_item .check_info .check_list .check_list_item {
        margin-right: 16px;
        font-size: 14px;
        margin-bottom: 6px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_title {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_title .titles {
        font-size: 24px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_title .titles_en {
        font-size: 24px;
        margin-left: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_title .titles_en img {
        width: 24px;
        margin-left: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-bottom: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_imgs {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_imgs img {
        min-height: 0;
        height: auto;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_info {
        padding: 16px 16px 16px 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_info .info_title {
        font-size: 20px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_info .item_tages {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_info .item_tages .tages {
        font-size: 14px;
        margin-right: 16px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items .item_info .item_tages .tages img {
        height: 19px;
        margin-right: 8px;
    }
    .Classroom.no-trans .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list .items2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Classroom.no-trans .Classroom_bom {
        padding-bottom: 16px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_title {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_title .titles {
        font-size: 24px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_title .titles_en {
        font-size: 24px;
        margin-left: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_title .titles_en img {
        width: 24px;
        margin-left: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-bottom: 16px;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px 16px 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_no {
        width: 76px;
        height: auto;
        right: 16px;
        top: -10px;
        font-size: 20px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_no img {
        width: 76px;
        height: 60px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_no span {
        margin-left: 10px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 20px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_const {
        padding-top: 16px;
        font-size: 14px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_tages {
        margin-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_tages .tages {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        margin-right: 16px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items .item_tages .tages img {
        height: 19px;
        margin-right: 8px;
    }
    .Classroom.no-trans .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list .items2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
}
@media (max-width: 1024px) {
    .Classroom.no-trans {
        .Classroom_top .check_box { margin: 0; padding: 16px; gap: 12px; }
        .Classroom_top .LAW_CLASS .LAW_CLASS_box, .Classroom_bom .LAW_CLASS_box { padding: 24px 16px; }
        .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_title,
        .Classroom_bom .LAW_CLASS_box .LAW_CLASS_title {
            align-items: baseline; flex-wrap: wrap; gap: 6px 12px;
            .titles { font-size: 20px; line-height: 28px; }
            .titles_en { font-size: 13px; line-height: 22px; margin: 0; padding: 0; img { display: none; } }
        }
        .Classroom_top .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list {
            display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 12px;
            .items2 { display: none; }
            .items { width: 100%; margin: 0; overflow: hidden; border-radius: 6px; }
            .items .item_imgs { height: auto; aspect-ratio: ~"16 / 10"; }
            .items .item_imgs img { width: 100%; height: 100%; object-fit: cover; }
            .items .item_info { padding: 12px; }
            .items .item_info .info_title { font-size: 15px; line-height: 24px; }
            .items .item_info .item_tages { gap: 8px; }
            .items .item_info .item_tages .tages { margin: 0; font-size: 13px; }
        }
        .Classroom_bom .LAW_CLASS_box .LAW_CLASS_list {
            .items2 { display: none; }
            .items { padding: 16px; margin-bottom: 16px; }
            .items .item_no { position: static; width: auto; height: auto; justify-content: flex-start; padding: 0 0 8px; font-size: 14px; img { display: none; } span { margin: 0; } }
            .items .item_titles { font-size: 17px; line-height: 27px; }
            .items .item_const { padding-top: 8px; line-height: 24px; }
            .items .item_tages { margin-top: 12px; padding-top: 12px; gap: 8px 12px; .tages { margin: 0; font-size: 13px; } }
        }
    }
}
@media (max-width: 1024px) {
    .Classroom.no-trans {
        .Classroom_top {
            .banners { height: auto; }
            .banners img { display: block; width: 100%; height: auto; }
            .check_box {
                box-sizing: border-box;
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                align-items: start;
                width: 100%; height: auto; margin: 0;
                padding: 12px 16px 0; gap: 0 16px;
                box-shadow: none; border-radius: 0;
                .check_item { display: grid; grid-template-columns: 24px minmax(0, 1fr); align-items: start; gap: 8px; width: 100%; margin: 0; padding: 4px 0; border-bottom: 1px solid #edf0f4; }
                .check_item .check_img { display: flex; align-items: center; height: 44px; }
                .check_item .check_img img { width: 24px; height: 24px; object-fit: contain; }
                .check_item .check_info { min-width: 0; padding: 0; }
                .check_item .check_info .check_title { display: flex; align-items: center; min-height: 44px; font-size: 15px; line-height: 22px; overflow-wrap: anywhere; }
                .check_item .check_info .check_list { display: flex; flex-wrap: nowrap; gap: 12px; padding: 0; overflow-x: auto; overscroll-behavior-x: contain; scrollbar-width: thin; }
                .check_item .check_info .check_list .check_list_item { display: inline-flex; align-items: center; flex: 0 0 auto; min-height: 44px; margin: 0; font-size: 13px; line-height: 20px; color: #748091; }
                .category_toggle { grid-column: ~"1 / -1"; display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; min-height: 44px; padding: 0; border: 0; background: #fff; color: #377cfd; font: inherit; font-size: 13px; cursor: pointer; }
            }
            .LAW_CLASS .LAW_CLASS_box {
                box-sizing: border-box; padding: 20px 16px 24px;
                .LAW_CLASS_title { padding: 0; align-items: center; flex-wrap: nowrap; gap: 8px; min-height: 44px; }
                .LAW_CLASS_title .titles_en { display: none; }
                .LAW_CLASS_title .mobile_more { display: flex; align-items: center; min-height: 44px; margin-left: auto; color: #748091; font-size: 13px; white-space: nowrap; }
                .LAW_CLASS_list {
                    align-items: stretch; padding-top: 10px;
                    .items { box-shadow: none; border: 1px solid #e7ecf2; border-radius: 6px; cursor: pointer; }
                    .items .item_imgs { position: relative; aspect-ratio: ~"16 / 10"; overflow: hidden; background: #e9eef5; }
                    .items .item_imgs .mobile_play { position: absolute; right: 8px; bottom: 8px; font-size: 25px; color: #fff; border-radius: 50%; background: rgba(0,0,0,.3); }
                    .items .item_info { padding: 10px; }
                    .items .item_info .info_title { height: 48px; font-size: 15px; line-height: 24px; overflow-wrap: anywhere; }
                    .items .item_info .item_tages { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding-top: 8px; }
                    .items .item_info .item_tages .tages { display: flex; align-items: center; gap: 5px; font-size: 13px; line-height: 20px; color: #748091; overflow-wrap: anywhere; }
                    .items .item_info .item_tages .tages img { width: 14px; height: 14px; object-fit: contain; margin: 0; }
                }
            }
        }
        .Classroom_bom {
            margin-top: 0; padding-bottom: 8px;
            .LAW_CLASS_box {
                box-sizing: border-box; padding: 16px;
                .LAW_CLASS_title { padding: 0; align-items: center; flex-wrap: nowrap; gap: 8px; min-height: 44px; }
                .LAW_CLASS_title .titles_en { display: none; }
                .LAW_CLASS_title .mobile_more { display: flex; align-items: center; min-height: 44px; margin-left: auto; color: #748091; font-size: 13px; white-space: nowrap; }
                .LAW_CLASS_list {
                    display: block; padding-top: 0;
                    .items, .items_bg { box-sizing: border-box; padding: 16px 0; margin: 0; background: #fff; background-image: none; border-radius: 0; border-bottom: 1px solid #e7ecf2; cursor: pointer; }
                    .items:last-of-type { border-bottom: 0; }
                    .items .item_no { display: none; }
                    .items .item_titles { color: #303846; font-size: 16px; line-height: 25px; -webkit-line-clamp: 2; overflow-wrap: anywhere; }
                    .items .item_const { color: #748091; font-size: 14px; line-height: 23px; -webkit-line-clamp: 2; padding-top: 6px; overflow-wrap: anywhere; }
                    .items .item_tages { gap: 6px 12px; margin-top: 10px; padding-top: 0; border: 0; }
                    .items .item_tages .tages { flex-wrap: nowrap; gap: 5px; color: #748091; font-size: 13px; line-height: 20px; }
                    .items .item_tages .tages:last-child { margin-left: auto; }
                    .items .item_tages .tages img { width: 14px; height: 14px; object-fit: contain; margin: 0; }
                }
            }
        }
        .mobile_empty { grid-column: ~"1 / -1"; padding: 28px 0; text-align: center; color: #748091; font-size: 14px; }
        [role="link"]:focus-visible, .category_toggle:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .Classroom.no-trans .Classroom_top {
        .check_box { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .LAW_CLASS .LAW_CLASS_box .LAW_CLASS_list { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    }
}
</style>
